// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-component{position:relative;overflow:hidden}.image-component__placeholder{width:100%;height:100%}.image-component__inner{display:block;width:100%;height:100%}.fade-in-enter,.fade-in-leave-to{opacity:0}.fade-in-enter-active,.fade-in-leave-active{-webkit-transition:opacity .48s cubic-bezier(.48,0,.12,1);transition:opacity .48s cubic-bezier(.48,0,.12,1)}", ""]);
// Exports
module.exports = exports;
